import { message } from "antd"
import axios from "axios"
import { getAuth, getIdToken } from "firebase/auth"
import { useMutation, useQuery, useQueryClient } from "react-query"

export const fetchLesson = async (enrolmentUid, lessonUid, queryClient, urlParams) =>
  axios
    .get(
      `${process.env.REACT_APP_API_URL}/learn/enrolments/${enrolmentUid}/learning/${lessonUid}${
        urlParams && urlParams.length ? `?${urlParams}` : ""
      }`,
      {
        headers: {
          Authorization: `Bearer ${await getIdToken(getAuth().currentUser)}`,
          "X-Tenant-Id": queryClient.getQueryData("token").claims.firebase.tenant,
        },
      }
    )
    .then((res) => res.data.data)

export const fetchAssessment = async (enrolmentUid, assessmentUid, queryClient, urlParams) =>
  axios
    .get(
      `${process.env.REACT_APP_API_URL}/learn/enrolments/${enrolmentUid}/assessment/${assessmentUid}${
        urlParams && urlParams.length ? `?${urlParams}` : ""
      }`,
      {
        headers: {
          Authorization: `Bearer ${await getIdToken(getAuth().currentUser)}`,
          "X-Tenant-Id": queryClient.getQueryData("token").claims.firebase.tenant,
        },
      }
    )
    .then((res) => res.data.data)

export const useGetLesson = ({ enrolmentUid, lessonUid, filters }) => {
  let params = {}

  if (window.localStorage.getItem("classroom")) {
    params = {
      ...params,
      classroom: true,
    }
  }

  if (filters) {
    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        params = {
          ...params,
          [key]: filters[key],
        }
      }
    })
  }

  const urlParams = new URLSearchParams(params).toString()
  const queryClient = useQueryClient()
  return useQuery(
    [enrolmentUid, "lesson", lessonUid],
    () => fetchLesson(enrolmentUid, lessonUid, queryClient, urlParams),
    {
      enabled: !!(enrolmentUid && lessonUid),
      staleTime: 1000 * 60 * 15,
      onError: (error) => {
        message.error(`Failed to fetch lesson: ${error.response.data.message}`)
      },
    }
  )
}

export const useGetAssessment = ({ enrolmentUid, assessmentUid, filters }) => {
  let params = {}

  if (window.localStorage.getItem("classroom")) {
    params = {
      ...params,
      classroom: true,
    }
  }

  if (filters) {
    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        params = {
          ...params,
          [key]: filters[key],
        }
      }
    })
  }

  const urlParams = new URLSearchParams(params).toString()
  const queryClient = useQueryClient()
  return useQuery(
    [enrolmentUid, "assessment", assessmentUid],
    () => fetchAssessment(enrolmentUid, assessmentUid, queryClient, urlParams),
    {
      enabled: !!(enrolmentUid && assessmentUid),
      staleTime: 1000 * 60 * 15,
      onError: (error) => {
        message.error(`Failed to fetch assessment: ${error.response.data.message}`)
      },
    }
  )
}

export const useSubmitAssessment = ({ enrolmentUid, assessmentUid }) => {
  const queryClient = useQueryClient()
  return useMutation(
    async (data) => {
      return axios
        .post(`${process.env.REACT_APP_API_URL}/learn/enrolments/${enrolmentUid}/assessment/${assessmentUid}`, data, {
          headers: {
            Authorization: `Bearer ${await getIdToken(getAuth().currentUser)}`,
            "X-Tenant-Id": queryClient.getQueryData("token").claims.firebase.tenant,
          },
        })
        .then((res) => res.data)
    },
    {
      onSuccess: (res) => {
        // queryClient.invalidateQueries()
        return res?.data
      },
      onError: (error) => {
        message.error(`Failed to submit assessment: ${error.response.data.message}`)
      },
    }
  )
}
